<template>
    <div>
        <ul class="nav nav-tabs nav-fill m-0 p-0">
            <li class="nav-item cp_pointer" @click="smsNotification()">
                <button class="nav-link btn-block" :class="sms_notification ? 'active' : ''" aria-current="page">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="20px"
                        viewBox="0 0 24 24"
                        width="20px"
                        :fill="sms_notification ? '#A0A0A1' : '#32CDB6'"
                    >
                        <path d="M0 0h24v24H0z" fill="none"/>
                        <path
                            d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"
                        />
                    </svg>
                    پیامک
                </button>
            </li>
            <li class="nav-item cp_pointer" @click="emailNotification()">
                <button class="nav-link btn-block" :class="email_notification ? 'active' : ''">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="20px"
                        viewBox="0 0 24 24"
                        width="20px"
                        :fill="email_notification? '#A0A0A1' : '#32CDB6'"
                    >
                        <path d="M0 0h24v24H0z" fill="none"/>
                        <path
                            d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                        />
                    </svg>

                    ایمیل
                </button>
            </li>
            <li class="nav-item cp_pointer" @click="telegramNotification()">
                <button class="nav-link btn-block" :class="telegram_notification ? 'active' : ''">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="20px"
                        viewBox="0 0 24 24"
                        width="20px"
                        :fill="telegram_notification ? '#A0A0A1' : '#32CDB6'"
                    >
                        <path d="M0 0h24v24H0z" fill="none"/>
                        <path id="telegram-1"
                              d="M18.384,22.779c0.322,0.228 0.737,0.285 1.107,0.145c0.37,-0.141 0.642,-0.457 0.724,-0.84c0.869,-4.084 2.977,-14.421 3.768,-18.136c0.06,-0.28 -0.04,-0.571 -0.26,-0.758c-0.22,-0.187 -0.525,-0.241 -0.797,-0.14c-4.193,1.552 -17.106,6.397 -22.384,8.35c-0.335,0.124 -0.553,0.446 -0.542,0.799c0.012,0.354 0.25,0.661 0.593,0.764c2.367,0.708 5.474,1.693 5.474,1.693c0,0 1.452,4.385 2.209,6.615c0.095,0.28 0.314,0.5 0.603,0.576c0.288,0.075 0.596,-0.004 0.811,-0.207c1.216,-1.148 3.096,-2.923 3.096,-2.923c0,0 3.572,2.619 5.598,4.062Zm-11.01,-8.677l1.679,5.538l0.373,-3.507c0,0 6.487,-5.851 10.185,-9.186c0.108,-0.098 0.123,-0.262 0.033,-0.377c-0.089,-0.115 -0.253,-0.142 -0.376,-0.064c-4.286,2.737 -11.894,7.596 -11.894,7.596Z"/>
                    </svg>
                    تلگرام
                </button>
            </li>
        </ul>
        <div v-if="sms_notification">
            <sms></sms>
        </div>
        <div v-if="email_notification">
            <Email></Email>
        </div>
        <div v-if="telegram_notification">
            <Telegram></Telegram>
        </div>
    </div>
</template>

<script>
import Sms from "@/pages/setting/sms";
import Email from "@/pages/setting/email";
import Telegram from "@/pages/setting/telegram";

export default {
    name: "NotificationSettings",
    components: {Email, Sms, Telegram},
    data() {
        return {
            telegram_notification: false,
            email_notification: false,
            sms_notification: true
        }
    },
    methods: {
        smsNotification() {
            this.telegram_notification = false
            this.email_notification = false
            this.sms_notification = true
        },
        emailNotification() {
            this.telegram_notification = false
            this.email_notification = true
            this.sms_notification = false
        },
        telegramNotification() {
            this.telegram_notification = true
            this.email_notification = false
            this.sms_notification = false
        },
    },
    mounted() {
        this.$store.dispatch("notification/fetch");
        this.$store.dispatch("notificationSms/fetch");
        this.$store.dispatch("notification/fetchTelegramNotification");

        if (this.$route.query.notif!== undefined) {
            this.telegramNotification()
        }

    }
}
</script>

<style scoped>

</style>